import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "mainTitle", "body", "action", "action2", "action3", "cancelAction", "confirmAction", "rootClassName", "className", "children", "isDark", "dark", "htmlProps"];
import { Col, Row } from "../../GridV2";
import parseClassnames from "../../helpers/parseClassnames";
import { DIALOG_CONTENT_COL_PROPS, DIALOG_SHEET_COL_PROPS } from "../constants";
import AlertActions from "./ui/AlertActions";
import Body from "./ui/Body";
import MainActions from "./ui/MainActions";
import MainTitle from "./ui/MainTitle";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DialogContent = function DialogContent(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'm' : _ref$type,
    mainTitle = _ref.mainTitle,
    body = _ref.body,
    action = _ref.action,
    action2 = _ref.action2,
    action3 = _ref.action3,
    cancelAction = _ref.cancelAction,
    confirmAction = _ref.confirmAction,
    _ref$rootClassName = _ref.rootClassName,
    rootClassName = _ref$rootClassName === void 0 ? '' : _ref$rootClassName,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children,
    isDark = _ref.isDark,
    dark = _ref.dark,
    htmlProps = _ref.htmlProps,
    dialogContentProps = _objectWithoutProperties(_ref, _excluded);
  var totalInnerCols = {
    xs: DIALOG_CONTENT_COL_PROPS[type].xs,
    sm: DIALOG_CONTENT_COL_PROPS[type].sm,
    md: DIALOG_CONTENT_COL_PROPS[type].md,
    lg: DIALOG_CONTENT_COL_PROPS[type].lg
  };
  return /*#__PURE__*/_jsx(Row, {
    className: parseClassnames(rootClassName, type !== 's' ? 'px-20 sm:px-0' : ''),
    totalCols: type === 'full' ? {
      xs: DIALOG_SHEET_COL_PROPS.full.xs
    } : {
      xs: DIALOG_SHEET_COL_PROPS[type === 'm-form' ? 'm' : type].xs,
      sm: DIALOG_SHEET_COL_PROPS[type === 'm-form' ? 'm' : type].sm,
      md: DIALOG_SHEET_COL_PROPS[type === 'm-form' ? 'm' : type].md,
      lg: DIALOG_SHEET_COL_PROPS[type === 'm-form' ? 'm' : type].lg
    },
    nowrap: true,
    children: /*#__PURE__*/_jsxs(Col, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      className: parseClassnames(className, type === 's' ? 'py-48 sm:py-56' : 'pt-56 pb-48 sm:pb-56'),
      offset: DIALOG_CONTENT_COL_PROPS[type].offset
    }, totalInnerCols), dialogContentProps), htmlProps), {}, {
      children: [mainTitle && /*#__PURE__*/_jsx(MainTitle, {
        type: type,
        mainTitle: mainTitle,
        isDark: isDark || dark,
        hasMoreElements: !!(body || action || action2 || action3 || cancelAction || confirmAction || children)
      }), body && /*#__PURE__*/_jsx(Body, {
        type: type,
        body: body,
        isDark: isDark || dark,
        hasMoreElements: !!(action || action2 || action3 || cancelAction || confirmAction || children)
      }), children, (confirmAction || cancelAction) && /*#__PURE__*/_jsx(AlertActions, {
        type: type,
        cancelAction: cancelAction,
        confirmAction: confirmAction,
        isDark: isDark || dark,
        totalInnerCols: totalInnerCols,
        hasMoreElements: !!(action || action2 || action3)
      }), (action || action2 || action3) && /*#__PURE__*/_jsx(MainActions, {
        type: type,
        action: action,
        action2: action2,
        action3: action3,
        isDark: isDark || dark,
        totalInnerCols: totalInnerCols
      })]
    }))
  });
};
export default DialogContent;